module.exports = __webpack_public_path__ + "img/inktober_2020_04_radio.74aeefb3.jpg";